import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms a string into a human readable string, meaning it performs the following operations:
 *  - Removes all underscores and replaces them with spaces
 *  - Capitalizes the string (each word)
 *
 * For example:
 * - 'example_string' => 'Example String'
 */
@Pipe({
    name: 'humanReadable',
})
export class HumanReadablePipe implements PipeTransform {
    transform(value: string): string {
        if (value) {
            value = this.removeUnderscore(value);
            value = this.capitalize(value);
        }

        return value;
    }

    private removeUnderscore(text: string): string {
        return text.replace(/_/g, ' ');
    }

    private capitalize(text: string): string {
        const textArr: Array<string> = text.split(' ');
        let capitalizedText = '';

        textArr.forEach((part: string) => {
            // put space before word (if it's not the first)
            if (capitalizedText !== '') {
                capitalizedText += ' ';
            }
            capitalizedText += part.charAt(0).toUpperCase() + part.slice(1);
        });

        return capitalizedText;
    }
}
